module.exports = __webpack_public_path__ + "img/carousel-3.ae87a2c5.jpg";